export const getTraineePositionById = (payload?: any) => ({
    type: "@saga/GET_TRAINEE_POSITION_BY_ID",
    payload
});